import {AssetId, CustomerId, ProjectId, UserId} from '../ids';
import * as _ from "lodash";

export interface User {
    id: UserId,
    name: string,
    accountStateForUser: string,
    accountStateTechnical: string,
    properties: any,
    customerId: CustomerId;
    groups: string[],
    projects: ProjectId[],
    administrativePermissions: Array<string>,
    publicProperties: any,
    hasSSOUserId: boolean,
    email?: string,
    lastActive?: Date,
    avatarId? : AssetId,
    isWebmateAdmin?: boolean
}


export function userFromBackendObject(profile: any): User {
    switch(profile.accountState) {
        case "created": profile['accountStateForUser']                      = "not ready - must complete Registration"; break; //TODO: needs to be internationalized
        case "invited": profile['accountStateForUser']                      = "not ready - must accept Invitation"; break;
        case "disabled_by_user": profile['accountStateForUser']             = "manually disabled"; break;
        case "disabled_by_system__attempts": profile['accountStateForUser'] = "automatically disabled - too many failed authentications"; break;
        case "disabled_by_system__pw_dated": profile['accountStateForUser'] = "automatically disabled - password too old"; break;
        default:
            profile['accountStateForUser'] = profile.accountState;
    }
    profile['accountStateTechnical'] = profile.accountState;
    delete profile.accountState;

    return profile as User;
}
